import { ObstetricalVisit } from "../../ObstetricalVisit";

class OntarioObstetricalVisit extends ObstetricalVisit {
    public SymphysisToFundalHeightCentimeters?: number;
    public UrineProtein: string;

    constructor(fields?: Partial<OntarioObstetricalVisit>) {
        super(fields);
        this.SymphysisToFundalHeightCentimeters = fields?.SymphysisToFundalHeightCentimeters;
        this.UrineProtein = fields?.UrineProtein;
    }
}

export { OntarioObstetricalVisit };
